import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './styles.scss';

export default class Client extends React.Component { // eslint-disable-line
  render() {
    const {
      client: { id, displayName, fullName, isPrimaryTraveler, primaryTraveler }, active,
    } = this.props;

    return (<Link
      to={`/clients/${id}/`}
      className={active ? styles.active : null}
    >
      <div className={styles.clientListItem}>
        {displayName || fullName}
        {(!isPrimaryTraveler && primaryTraveler && <div
          className={styles.primaryTravelerName}
        >
          ({primaryTraveler.fullName})
        </div>) || null}
      </div>
    </Link>);
  }
}

Client.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.string,
    fullName: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// /src/components/Clients/Client.js